import { render, staticRenderFns } from "./list-groups.vue?vue&type=template&id=db79dbc4&"
import script from "./list-groups.vue?vue&type=script&lang=js&"
export * from "./list-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports